<template lang="pug">
.modal-backdrop(v-if="visible", @touchmove.prevent)
  .modal-container
    .modal-header(v-if="title")
      span {{ title }}
    .modal-body
      slot(name="body")
    .modal-footer(
      :class="{ row: btnDirection === 'row', column: btnDirection === 'column' }"
    )
      .btn.cancel(
        v-if="showCancel"
        @click="cancel",
        :class="{ border: subBtnBorder, narrow: !subBtnBorder }",
        :style="{ 'border-color': color, color }"
      ) {{ subBtnText }}
      .divider
      .btn.sure(@click="confirm", :style="{ background: color }") {{ btnText }}
    .modal-close(@click="close")
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    btnText: {
      type: String,
      default: '确认',
    },
    color: {
      type: String,
      default: '#0b82f1',
    },
    btnDirection: {
      type: String,
      default: 'row',
    },
    subBtnText: {
      type: String,
      default: '取消',
    },
    subBtnBorder: {
      type: Boolean,
      default: true,
    },
    onConfirm: {
      type: Function,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      param: {}, // close时发送
    };
  },
  methods: {
    open(options, param = {}) {
      this.visible = true;
      this.param = param;
      if (options) {
        Object.assign(this, options || {});
      }
    },
    cancel() {
      this.visible = false;
      this.$emit('cancel', this.param);
    },
    close() {
      this.visible = false;
      this.$emit('close', this.param);
    },
    confirm() {
      this.$emit('confirm', this.param);
      this.onConfirm();
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 3.2rem;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: #fff;

  .modal-close {
    margin: 0;
    display: block;
    position: fixed;
    top: 0.14rem;
    right: 0.14rem;
    width: 0.2rem;
    height: 0.2rem;
    z-index: 2000;

    &::before,
    &::after {
      content: " ";
      display: block;
      position: absolute;
      top: 0.04rem;
      right: -0.02rem;
      width: 0.16rem;
      height: 2px;
      transform: translateY(-50%) rotate(45deg);
      background-color: #bcc4cc;
      border-radius: 4px;
    }

    &::after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }

  .modal-header {
    padding: 0.24rem 0 0.12rem 0;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
  }

  .modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 0 0.16rem 0;
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 0.14rem;
    color: rgba(102, 102, 102, 1);
  }

  .modal-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.2rem 0.16rem 0.16rem;
    position: relative;

    .divider {
      order: 2;
    }

    &.row {
      flex-direction: row;

      .divider {
        width: 0.08rem;
        height: 100%;
      }

      .sure {
        order: 3;
      }

      .cancel {
        order: 1;
      }
    }

    &.column {
      flex-direction: column;

      .divider {
        height: 0.1rem;
        width: 100%;
      }

      .sure {
        order: 1;
      }

      .cancel {
        order: 3;

        &.narrow {
          margin-bottom: -0.08rem;
        }
      }
    }

    .btn {
      background: #0b82f1;
      font-size: 18px;
      line-height: 0.48rem;
      height: 0.48rem;
      flex: 1;
      text-align: center;
      color: #fff;
      border-radius: 8px;

      &.cancel {
        background-color: white;
        color: #0b82f1;

        &.border {
          border: 1px solid #0b82f1;
        }
      }
    }
  }
}
</style>
